export default function (state = [], action) {
    switch (action.type) {
        case 'PRIORITIES_ITEM_CHANGE':
            return action.payload;
            break;
    }
    return state;
}

/*
access_id: action.payload["access id"],
new_priority: action.payload["new_priority"],
*/



// WEBPACK FOOTER //
// ./src/config/allReducers/prioritychangeid/prioritychangeid.js